export default __webpack_public_path__ + "static/media/login-hero.bf157d67.png";